import { getMessage } from '../config/messages';
import toast from 'react-hot-toast';

/**
 * Toast notification helper using message keys
 * Provides consistent toast messages across the application
 */

/**
 * Show success toast using message key
 * @param messageKey - Message key (e.g., 'auth.loginSuccess')
 * @param params - Optional parameters for string replacement
 */
export const showSuccessToast = (messageKey, params = {}) => {
  const message = getMessage(messageKey, params);
  toast.success(message);
};

/**
 * Show error toast using message key
 * @param messageKey - Message key (e.g., 'auth.passwordNotMatch')
 * @param params - Optional parameters for string replacement
 */
export const showErrorToast = (messageKey, params = {}) => {
  const message = getMessage(messageKey, params);
  toast.error(message);
};

/**
 * Show loading toast using message key
 * @param messageKey - Message key
 * @param params - Optional parameters for string replacement
 */
export const showLoadingToast = (messageKey, params = {}) => {
  const message = getMessage(messageKey, params);
  return toast.loading(message);
};

/**
 * Show custom toast using message key
 * @param messageKey - Message key
 * @param type - Toast type ('success', 'error', 'loading', 'blank')
 * @param params - Optional parameters for string replacement
 */
export const showToast = (messageKey, type = 'blank', params = {}) => {
  const message = getMessage(messageKey, params);
  return toast[type](message);
};

/**
 * Dismiss a specific toast
 * @param toastId - Toast ID returned from toast functions
 */
export const dismissToast = (toastId) => {
  if (toastId) {
    toast.dismiss(toastId);
  }
};

/**
 * Dismiss all toasts
 */
export const dismissAllToasts = () => {
  toast.dismiss();
};

/**
 * Get message string without showing toast
 * @param messageKey - Message key
 * @param params - Optional parameters for string replacement
 */
export const getMessageString = (messageKey, params = {}) => {
  return getMessage(messageKey, params);
};

export default {
  showSuccessToast,
  showErrorToast,
  showLoadingToast,
  showToast,
  dismissToast,
  dismissAllToasts,
  getMessageString,
};
